var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpectImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 153.9 142.8",
    style: {
      enableBackground: "new 0 0 153.9 142.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9EABC0;}\n\t.st1{fill:#C3D7FF;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1.2,141.6 5.5,129.4 45,88.1 69.4,110 137.5,66.8 137.5,141.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2,91.4c0,0-13.4-15.8-11-42.6S55.1,6.2,55.1,6.2s25.6-14,51.1,0s30.4,35.3,30.4,35.3s3,12.8,0,24.3 l-9.7,6.1c0,0,4.9-17-1.2-31.6c-4.9-7.3-8.5-19.5-28.6-27.4c-8.5-1.2-24.3-6.1-42.6,6.7c-6.7,6.1-15.8,11.6-18.3,31 c0,6.1-3.7,17.6,7.9,33.5L36.2,91.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 49.3,
    cy: 56.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 81.5,
    cy: 87.4,
    r: 6.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M77.3,23v31.6c0,0-1.2,6.7,6.7,6.7s29.2,0,29.2,0s7,0.9,7-4.6c0,0-1.2-4.3-7.3-4.3c-6.1,0-26.8,0-26.8,0V23.3 c0,0,0-4.9-4.3-4.9C77.6,18.4,77.3,23,77.3,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.3,21.1v26.2h25.6C116.8,47.3,116.2,26.6,91.3,21.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "0,142.8 42.6,99.6 70,121.5 153.9,63.1 153.9,47.3 69.4,103.9 42.6,80.8 0,125.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpectImage);
export default __webpack_public_path__ + "static/media/expectImage.fd88303c6e9590cc23f7c609604aa5f8.svg";
export { ForwardRef as ReactComponent };